import {
  AcademicCapIcon,
  CalendarDaysIcon,
  NewspaperIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";

export const ADMIN_SECTIONS = [
  {
    key: "clients",
    path: "/admin/clientes",
    label: "Clientes",
    icon: UserGroupIcon,
  },
  {
    key: "psychologists",
    path: "/admin/psicologos",
    label: "Psicólogos",
    icon: AcademicCapIcon,
  },
  {
    key: "appointments",
    path: "/admin/citas",
    label: "Citas",
    icon: CalendarDaysIcon,
  },
  {
    key: "revistas",
    path: "/admin/revistas",
    label: "Conexión Siete",
    icon: NewspaperIcon,
  },
];

/** @deprecated usar path; se mantiene por redirects legacy ?seccion= */
export function adminSectionFromParam(param) {
  const legacy = {
    clientes: "clients",
    psicologos: "psychologists",
    citas: "appointments",
    revistas: "revistas",
  };
  return legacy[param] || ADMIN_SECTIONS[0].key;
}

export function adminPathFromSection(key) {
  const match = ADMIN_SECTIONS.find((s) => s.key === key);
  return match?.path || ADMIN_SECTIONS[0].path;
}

export function adminSectionFromPathname(pathname) {
  const path = String(pathname || "");
  if (path.startsWith("/admin/revistas")) return "revistas";
  if (path.startsWith("/admin/citas")) return "appointments";
  if (path.startsWith("/admin/psicologos")) return "psychologists";
  if (path.startsWith("/admin/clientes")) return "clients";
  return ADMIN_SECTIONS[0].key;
}

export function isAdminSectionActive(pathname, sectionKey) {
  return adminSectionFromPathname(pathname) === sectionKey;
}
